import {TableContainer as MuiTableContainer, Paper} from '@mui/material';
import type {TableProps} from './table';

type TableContainerProps = TableProps;

export function TableContainer(props: TableContainerProps) {
  return (
    <MuiTableContainer
      component={Paper}
      sx={{
        padding: '30px 22px 22px',
        backgroundColor: 'white',
        boxShadow: '0px 4px 16px rgba(29, 41, 57, 0.15)',
        borderRadius: '8px',

        // Make table scrollable within
        position: 'absolute',
        width: '-webkit-fill-available',
        overflowX: 'auto',
        overflowY: 'auto',
        marginRight: '16px',
        marginTop: '16px',

        // Table styles
        '& .MuiTable-root': {
          borderCollapse: 'separate',
          borderSpacing: '0px 14px',
        },

        // Header styles
        '& .MuiTableHead-root': {
          // Header cell styles
          '& .MuiTableCell-head': {
            padding: '10px 8px',
            '& p': {
              fontWeight: 500,
              fontSize: '18px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              textWrap: 'nowrap',
            },
          },
        },

        // Body styles
        '& .MuiTableBody-root': {
          // Body row styles
          '& .MuiTableRow-root': {
            '&:hover': {
              backgroundColor: props.loading ? 'inherit' : 'blue.hover',
              cursor: props.loading ? 'inherit' : 'pointer',
            },
          },
          // Body cell styles
          '& .MuiTableCell-root': {
            padding: '0px 8px',
            borderBottom: 'none',
            maxWidth: '200px',
            '& p': {
              fontWeight: 500,
              fontSize: '16px',
              color: 'gray.main',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              textWrap: 'nowrap',
            },

            '&:first-of-type': {
              paddingLeft: '12px',
              borderTopLeftRadius: '5px',
              borderBottomLeftRadius: '5px',
            },
            '&:last-child': {
              paddingRight: '12px',
              borderTopRightRadius: '5px',
              borderBottomRightRadius: '5px',
            },
          },
        },
      }}
    >
      {props.children}
    </MuiTableContainer>
  );
}
